import React, { Fragment } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { Col } from "react-bootstrap";
import UnitHome from "./UnitHome";

export default function UnitList() {
  return (
      <Fragment>
            <Breadcrumbs mainTitle="List of Units" parent="Home" title="List of Units" />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                        <UnitHome/>
                    </Col>
                </Row>
            </Container>
        </Fragment>
  )
}
